// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"1f05f3af","331":"e3616237","453":"ce8f5746","567":"84aedccb","821":"53ca26f0"}[chunkId] + ".chunk.js";
};